import { get, post } from "../GenericServices";

const Settings = {
  getSettings: () => {
    return get("settings");
  },
  saveSettings: (daysNumber) => {
    return post("settings", daysNumber);
  },
};

export default Settings;
